import { Controller } from "@hotwired/stimulus"
import { copyText, fill } from "../../lib/format"

const FIELDS = ["source", "medium", "campaign", "term", "content"]

// Appends the same UTM parameters to every URL, one per line.
export default class extends Controller {
  static targets = ["urls", "source", "medium", "campaign", "term", "content", "lowercase", "output", "copy", "status"]
  static values = { messages: Object }

  connect() { this.build() }

  build() {
    const lower = this.lowercaseTarget.checked
    const params = FIELDS
      .map(field => [field, this[`${field}Target`].value.trim()])
      .filter(([, value]) => value)
      .map(([field, value]) => [`utm_${field}`, lower ? value.toLowerCase() : value])

    const lines = this.urlsTarget.value.split("\n").map(l => l.trim()).filter(Boolean)
    let bad = 0
    const out = lines.map(line => {
      try {
        const url = new URL(/^[a-z][a-z0-9+.-]*:\/\//i.test(line) ? line : `https://${line}`)
        for (const [key, value] of params) url.searchParams.set(key, value)
        return url.toString()
      } catch {
        bad++
        return fill(this.messagesValue.not_a_url, { line })
      }
    })

    this.outputTarget.value = out.join("\n")
    this.statusTarget.textContent = lines.length
      ? fill(this.messagesValue.tagged, { count: lines.length - bad }) + (bad ? fill(this.messagesValue.skipped, { count: bad }) : "")
      : ""
  }

  copy() {
    copyText(this.outputTarget.value, this.copyTarget, this.messagesValue)
  }
}
